import { LoginPinFrequencyModel } from "@/Common/Models/Employee/LoginFrequencyModel";
import { SendObstetricalFileFormStrategy } from "@/Patient/Services/Portal/Strategies/SendObstetricalFileFormStrategy";
import { PortalPopupModel } from "@/Portal/Models/PortalPopupModel";
import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";
import { BaseSendMedicalNoteItemToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendMedicalNoteItemToPortalPopupStrategy";

class ObstetricalFileSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("FormLabel");
    }

    public getItemIconClass(): string {
        return "requestIcon";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return true;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(portalPopupModel: PortalPopupModel, onSignatureAccepted: () => void): BaseSendMedicalNoteItemToPortalPopupStrategy | null {
        return new SendObstetricalFileFormStrategy(portalPopupModel, () => onSignatureAccepted());
    }

    public getPinFrequencyToken(loginPinFrequencyModel: LoginPinFrequencyModel): string {
        return loginPinFrequencyModel?.obstetricalFileToken ?? "";
    }

    public getPinFrequencyDocumentType(): null {
        return null;
    }
}

export { ObstetricalFileSharedItemProvider };
